<script setup lang="ts"></script>

<template>
  <li class="dropdown topbar-li-style">
    <slot name="trigger"></slot>
    <slot></slot>
  </li>
</template>
